import React from 'react';

/**
 * SubscriptionStatusBadge Component
 * Single Responsibility: Display subscription status with appropriate styling
 */
const SubscriptionStatusBadge = ({ subscription }) => {
  if (!subscription || !subscription.subscription_status) {
    return (
      <span className="px-2 py-1 rounded text-xs bg-gray-100 text-gray-600">
        No Subscription
      </span>
    );
  }

  const status = subscription.subscription_status;
  const statusConfig = {
    active: { bg: 'bg-green-100', text: 'text-green-800', label: 'Active' },
    trial: { bg: 'bg-blue-100', text: 'text-blue-800', label: 'Trial' },
    suspended: { bg: 'bg-yellow-100', text: 'text-yellow-800', label: 'Suspended' },
    cancelled: { bg: 'bg-red-100', text: 'text-red-800', label: 'Cancelled' },
    expired: { bg: 'bg-gray-100', text: 'text-gray-800', label: 'Expired' }
  };

  const config = statusConfig[status] || statusConfig.expired;

  return (
    <span className={`px-2 py-1 rounded text-xs font-semibold ${config.bg} ${config.text}`}>
      {config.label}
    </span>
  );
};

export default SubscriptionStatusBadge;

